import queryString from 'query-string';

import StartValue from './StartValue';
import EndValue from './EndValue';
import Params from './Params';
import StartController from './StartController';
import EndController from './EndController';

/**
 * DDDのfactory
 * このモジュールに必要な全てのクラスの生成を担当
 */
class Factory {
  /**
   * モジュールを作成
   *
   * @param {mix} player
   * @returns {void}
   */
  static create(player) {
    // console.log(player);
    const parsed = queryString.parse(window.location.search);
    // console.log(parsed);
    // alert(JSON.stringify(parsed));

    const startValue = new StartValue(parsed);
    // console.log(startValue);
    // console.log(startValue.start);
    // alert(startValue.start);

    const endValue = new EndValue(parsed);
    // console.log(endValue);
    // console.log(endValue.end);
    // const s = new StartValue();

    const params = new Params(startValue,endValue);
    // console.log(params.start);
    // alert(params.start);
    // console.log(params.end);

    const startController = new StartController(player, params);
    const endController = new EndController(player, params);
    return {
      parsed,
      startValue,
      endValue,
      params,
      startController,
      endController,
    };
  }
};

export default Factory;
